export default "__VITE_ASSET__Q375M46a__"